import { render, staticRenderFns } from "./dic_process_edit.vue?vue&type=template&id=6e6de23a&scoped=true"
import script from "./dic_process_edit.vue?vue&type=script&lang=js"
export * from "./dic_process_edit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e6de23a",
  null
  
)

export default component.exports